import React, { useContext, useEffect, useState } from 'react'
import SideBarLayout from '../layouts/SideBarLayout'
import SideBarLayout2 from '../layouts/SideBarLayout2'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCircleDot, faEllipsis, faPaperPlane, faPlus, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import AppContext from '../contexts/AppContext';
import { toast } from 'react-toastify';
import authService from '../authentication';
import instance from '../api/client';
import IconButton from '../components/IconButton';
import { Icon } from 'leaflet';
// import defaultMarkerIconPng from "leaflet/dist/images/marker-icon.png";
import defaultMarkerIconPng from "../assets/marker.png";
import NotifItem from '../components/NotifItem';
import Loader from '../components/loaders/Loader';
import StatCard from '../components/StatCard';
import PieChart from '../components/PieChart';


export default function Dashboard({ }) {
    const navigate = useNavigate()
    const [stats, setStats] = useState({})
    const [pieChartInfo, setPieChartInfo] = useState()
    const [loading, setLoading] = useState(false)
    const { user, setNavHeaderText } = useContext(AppContext)
    const [lastProject, setLastProject] = useState({})

    useEffect(() => {
        setNavHeaderText('Dashboard')
        getLastProject();
        getStats()
    }, [])

    const getStats = async () => {
        setLoading(true)
        try {
            const { data, status } = await instance.get(`/projects/all-projects-by-user
            `, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            setStats(data)
            console.log('Stats: ', data)
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)
    }

    const getPieData = async (projectCode) => {
        setLoading(true)
        try {
            const { data, status } = await instance.get(`/prioritize/major-groups-pieChart/${projectCode}/${5}

            `, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            setPieChartInfo(data)
            console.log('Pie: ', data)
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)
    }

    const getLastProject = async () => {
        setLoading(true)
        try {
            const { data, status } = await instance.get(`/projects/all-projects`, {
                headers: {
                    Authorization: `Bearer ${authService.getCurrentUser()}`
                }
            })
            if (data.length) {
                setLastProject(data[data.length - 1])
                getPieData(data[data.length - 1].code)
            }
        } catch (error) {
            toast.error(`Error: ${error}`, {
                position: toast.POSITION.TOP_CENTER
            });
        }
        setLoading(false)
    }

    return (
        <SideBarLayout2 title={'Dashboard'}>
            <div className='w-full overflow-y-scroll'>
                <div className='flex gap-5 justify-center p-6 pt-0 mx-5'>

                    <div className="w-full gap-4">

                        <div className="flex-1 mx-5 py-5 rounded">
                            <div className='flex gap-2 mb-5'>
                                <StatCard className={'w-[25%]'} number={stats?.no_of_projects || 0} text={'NO. OF PROJECTS'} />
                                <StatCard className={'w-[25%]'} number={stats?.no_of_collaborators || 0} text={'NO. OF COLLABORATORS'} />
                                <StatCard className={'w-[25%]'} number={stats?.no_of_impacts || 0} text={'NO. OF IMPACTS'} />
                                <StatCard className={'w-[25%]'} number={stats?.no_of_diagrams || 0} text={'NO. OF RISK ANALYSIS PERFORMED'} />
                            </div>

                            {
                                lastProject?.name &&
                                <MapContainer style={{
                                    height: '35vh',
                                    width: '100%',
                                }}
                                    minZoom={2} // just added so you cannot go out of area
                                    maxBounds={[[-90, -180], [90, 180]]}
                                    zoom={3}
                                    maxZoom={8}
                                    center={lastProject.location.coordinates}
                                >
                                    <TileLayer
                                        url={'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}'}
                                        attribution={'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>'}
                                    />

                                    <Marker position={lastProject.location.coordinates} icon={new Icon({ iconUrl: defaultMarkerIconPng, iconSize: [25, 41], iconAnchor: [12.5, 41] })}>
                                        <Popup>
                                            <div className='font-semibold capitalize mt-2 mb-1'>{lastProject?.name}</div>
                                            <div className='flex justify-center items-center'>
                                                (<div>{lastProject?.location.coordinates[0]}</div>, <div>{lastProject?.location.coordinates[1]}</div>)
                                            </div>
                                            <IconButton boxClassName={'w-full mt-2'} onClick={() => { navigate('/project-info/bowties', { state: { project: lastProject } }) }} icon={faPaperPlane} />
                                        </Popup>
                                    </Marker>
                                </MapContainer>
                            }
                            {
                                !lastProject?.name &&
                                <MapContainer style={{
                                    height: '35vh',
                                    width: '100%',
                                }}
                                    minZoom={2} // just added so you cannot go out of area
                                    maxBounds={[[-90, -180], [90, 180]]}
                                    zoom={3}
                                    maxZoom={8}
                                    center={[30.879, 8.6997]}
                                >
                                    <TileLayer
                                        url={'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryTopo/MapServer/tile/{z}/{y}/{x}'}
                                        attribution={'Tiles courtesy of the <a href="https://usgs.gov/">U.S. Geological Survey</a>'}
                                    />
                                </MapContainer>
                            }

                        </div>

                        {!loading && lastProject?.name &&
                            <div className='flex items-start mx-2'>
                                <div onClick={() => { navigate('/project-info/bowties', { state: { project: lastProject } }) }} className='cursor-pointer w-[60%] rounded-xl bg-gradient-to-b from-[#163F63] to-[#0E3458] text-white py-5 m-2 duration-300 rounded'>
                                    <div className='flex gap-5 mx-10 items-center text-xl font-bold mb-2'>
                                        <FontAwesomeIcon icon={faPaperPlane} className='' size='lg' />
                                        <div>
                                            Continue where you left off
                                        </div>
                                    </div>
                                    <div className='h-[2px] w-full bg-white rounded-full my-3' />
                                    <div style={{ fontFamily: 'RobotoCondensed' }} className='mx-10 '>Last Project </div>
                                    <div style={{ fontFamily: 'RobotoCondensed' }} className='mx-10 text-white mb-2'>{lastProject.name} </div>
                                    <div style={{ fontFamily: 'RobotoCondensed' }} className='mx-10 '>Description </div>
                                    <div style={{ fontFamily: 'RobotoCondensed' }} className='mx-10 text-white line-clamp-4'>{lastProject.description} </div>
                                </div>
                                <div onClick={() => { navigate('/project-info/bowties', { state: { project: lastProject } }) }} className='cursor-pointer w-[40%] rounded-xl bg-gradient-to-b from-[#163F63] to-[#0E3458] text-white py-5 m-2 duration-300 rounded'>
                                    <div className='flex gap-5 mx-5 justify-between items-center text-lg mb-2'>
                                        <div>
                                            Prioritised Pie Chart
                                        </div>
                                        <FontAwesomeIcon icon={faEllipsis} className='' size='lg' />
                                    </div>
                                    <div className='h-[2px] w-full bg-white rounded-full my-3' />
                                    <div className='px-5'>
                                        {pieChartInfo?.message? pieChartInfo.message:
                                        pieChartInfo && <PieChart labels={pieChartInfo.map((i)=>i.group_name)} series={pieChartInfo.map((i)=>i.percentage)} />
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                        }

                        {loading &&
                            <div className='flex flex-1 p-10 items-center justify-center opacity-60'>
                                <Loader animationName={'loader'} width={150} height={150} />
                            </div>
                        }
                    </div>

                    <div className="flex flex-col gap-4 w-[50%] h-[80vh]">

                        <div onClick={() => navigate('/workarea', { state: { create: true } })} className='cursor-pointer hover:scale-[0.95] rounded-xl bg-gradient-to-b from-[#163F63] to-[#0E3458] text-white py-5 m-2 mt-5 duration-300 rounded'>
                            <div className='flex gap-5 mx-10 items-center text-xl font-bold mb-2'>
                                <div>
                                    New Project
                                </div>
                            </div>
                            <div className='h-[2px] w-full bg-white rounded-full my-3' />
                            {/* <div style={{ fontFamily: 'Roboto' }} className='text-2xl'>Hi, {user.sub}</div> */}
                            <div style={{ fontFamily: 'RobotoCondensed' }} className='mx-10 '>Create a new project and analyse risks with ease</div>
                            <div className='flex items-center mt-4 mx-10'>
                                <FontAwesomeIcon icon={faPlus} size='2x' />
                                {/* <div className='text-2xl font-bold ml-2'>New Project</div> */}
                            </div>
                        </div>
                        {
                            !loading &&
                            <div className='bg-white mx-2'>
                                <div className='bg-gradient-to-b from-[#163F63] to-[#0E3458] rounded-xl px-10 py-5'>
                                    <FontAwesomeIcon icon={faBell} className='text-white mb-2 ' size='2x' />
                                    <div className='text-xl text-white font-bold'>What you may have missed</div>
                                </div>
                                <div className='bg-white cursor-pointer text-teal-600 shadow-lg p-5 mt-2 w-50 rounded'>
                                    <div style={{ fontFamily: 'RobotoCondensed' }} className=''>
                                        <NotifItem actor={'Raphaella'} action={'created a new diagram'} time={'Yesterday'} />
                                        <NotifItem actor={'Raphaella'} action={'created a new diagram'} time={'Yesterday'} />
                                    </div>
                                    {/* <div style={{ fontFamily: 'RobotoCondensed' }} className=''>
                                    <div className='flex items-center'>
                                        <FontAwesomeIcon className='text-gray-300 h-12 w-12' icon={faUserCircle} />
                                    </div>
                                </div> */}
                                </div>
                            </div>
                        }
                        {
                            loading &&
                            <div className='bg-white cursor-pointer text-teal-600 shadow-lg p-10 mt-2 w-50 rounded'>
                                <div className='flex flex-1 p-10 items-center justify-center opacity-60'>
                                    <Loader animationName={'loader'} width={150} height={150} />
                                </div>
                            </div>
                        }
                        {/* <div className='bg-white h-[385px] shadow-lg p-10 mt-2 w-50 rounded'>
                                <FontAwesomeIcon icon={faPaperPlane} />
                                <div className='text-2xl font-bold'>Hi, {user.sub}</div>
                                <div style={{fontFamily: 'RobotoCondensed'}} className=''>Continue where you left off</div>
                                <div className='bg-teal-600 flex justify-center py-2 mt-2 rounded text-white'>Create a new project</div>
                            </div> */}
                        {/* <Card className={'bg-gray-700/80'} numberIcons={[fa1, fa0]} title={'No. of Projects'} icon={faProjectDiagram} />
                            <Card className={'bg-fuchsia-700/80'} numberIcons={[fa1, fa9]} title={'No. of Colabs'} icon={faUserGroup} />
                            <Card className={'bg-orange-700/80'} numberIcons={[fa8]} title={'No. of Models'} icon={faPrescription} />
                            <Card className={'bg-teal-700/80'} numberIcons={[fa8]} title={'No. of Locations'} icon={faLocation} /> */}

                    </div>

                </div>
            </div>
        </SideBarLayout2>
    )
}
